import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { filter, firstValueFrom, Subscription, take } from 'rxjs';
import { BaseComponent } from './base-component.component';
import { ValidationHandlerService } from '../../services/validation-handler.service';
import { LanguageListModel, LanguageListModelListBaseResponse } from '../../services/api-services';
import { ICoreService } from '../../interfaces/core-service.interface';
import { LocalStorageWrapper } from '../../classes/local-storage-wrapper.class';
import { LanguageId } from '../../enums/language-id.enum';
import { IAuthenticationService } from '../../interfaces/authentication-service.interface';
import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { AuthenticationService_TOKEN, CoreService_TOKEN } from '../../tokens/injection-tokens';
import { ClaimTypes } from '../../claim-types';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageService } from '../../services/language.service';
import { ISiteSettings } from '../../interfaces/site-settings.interface';
import { AuthSubscriptionService } from '../../services/auth-subscription.service';
declare var $: any;

@Component({
    template: ''
})
export class MenuBaseComponent extends BaseComponent {
    @ViewChild('navbar', { static: false }) navbar!: ElementRef;

    private _showMenu: boolean;
    public get showMenu(): boolean {
        return this._showMenu;
    }
    public set showMenu(value: boolean) {
        this._showMenu = value;
    }

    public languages: LanguageListModel[];
    public user: string;
    private subscriptionFirst?: Subscription;
    private subscriptionSecond?: Subscription;

    protected selectedLanguage: string;

    private isPublicSite: boolean;

    constructor(
        @Inject(CoreService_TOKEN) protected coreService: ICoreService,
        @Inject(AuthenticationService_TOKEN) protected authenticationService: IAuthenticationService,
        protected override validationHandlerService: ValidationHandlerService,
        protected translateService: TranslateService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService,
        protected authSubscriptionService: AuthSubscriptionService,
    ) {
        super(spinnerService, modalService, validationHandlerService);

        this.isPublicSite = LocalStorageWrapper.getObject<ISiteSettings>('SiteSettings')?.isPublicSite;
    }

    ngOnInit() {
        this.init();

        this.subscriptionFirst = this.authSubscriptionService.authChanged.subscribe((isUserAuthenticated: boolean) => {
            this.showMenu = isUserAuthenticated;

            if (this.showMenu) {
                let dToken = this.authenticationService.getDecodedToken();
                this.user = dToken[ClaimTypes.Email];
            }
        });

        this.subscriptionSecond = this.authSubscriptionService.authChanged.pipe(
            filter(value => value === true),
            take(1)
        ).subscribe(value => {
            if (this.showMenu) {
                // this.messageService.triggerUnreadCountReload();
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscriptionFirst) {
            this.subscriptionFirst.unsubscribe();
        }

        if (this.subscriptionSecond) {
            this.subscriptionSecond.unsubscribe();
        }

        // this.messageService.stopUnreadMessageCountPolling();
    }

    public init() {
        this.handleSpinner(firstValueFrom(this.coreService.getLanguageList())
            .then((res: LanguageListModelListBaseResponse) => {
                this.languages = res.result;
                let languageStrings: string[] = this.languages.map((a: LanguageListModel) => a.shortCode);
                this.translateService.addLangs(languageStrings);
                if (LocalStorageWrapper.isLocaleSet()) {
                    this.translateService.setDefaultLang(LocalStorageWrapper.getLocale());
                    this.translateService.use(LocalStorageWrapper.getLocale());
                } else {
                    let defaultLanguage = this.languages.find(x => x.id == LanguageId.En);
                    let defaultLocale = defaultLanguage.shortCode;
                    this.translateService.setDefaultLang(defaultLocale);
                    this.translateService.use(defaultLocale);
                    LocalStorageWrapper.setLocale(defaultLocale, defaultLanguage.id);
                    this.languageService.changeLanguage(defaultLocale);
                }
                this.initSelect();
                this.selectedLanguage = LocalStorageWrapper.getLocale();
                return Promise.resolve(res);
            }).catch((err: HttpErrorResponse) => {
                this.validationHandlerService.handleServerError(err)
            }));
    }

    public initSelect(): void {
        $("#languageSelector").select2({
            templateResult: formatLanguage,
            templateSelection: formatLanguage,
        });

        $("#languageSelector").on('select2:select', (languageSelector: any) => {
            this.changeLanguage(languageSelector.target.value);
        });

        function formatLanguage(language: any) {
            var name = $(language.element).data("name");
            var $language = $(
                '<span style="font-size: 1rem">' + name + '</span>'
            );
            return $language;
        }
    }

    public changeLanguage(languageShortCode: any) {
        let language: string = languageShortCode;
        this.translateService.use(language)
        this.translateService.setDefaultLang(language);
        let defaultLanguage = this.languages.find(x => x.shortCode == languageShortCode);
        LocalStorageWrapper.setLocale(language, defaultLanguage.id);
        this.languageService.changeLanguage(language);
    }

    public logout = () => {
        this.authenticationService.logout();
    }

    public closeMenu() {
        if (window.innerWidth < 992) {
            const navbarElement = this.navbar.nativeElement;
            if (navbarElement.classList.contains('show')) {
                navbarElement.classList.remove('show');
            }
        }
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const clickedInside = this.navbar.nativeElement.contains(event.target);
        if (!clickedInside) {
            this.closeMenu();
        }
    }
}
